// components/AuthInitializer.jsx
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  checkAuthState,
  getUserDefaultPaymentMethod,
  getUserSubscription
} from "../store/auth/authActions";

const AuthInitializer = ({ children }) => {
  const dispatch = useDispatch();
  const { isAuthenticated, user, currentSubscription } = useSelector(
    (state) => state.auth
  );
  const currentPlan = currentSubscription?.previousPlanId
    ? currentSubscription?.previousPlanId
    : currentSubscription?.planId;
  useEffect(() => {
    dispatch(checkAuthState());
  }, [dispatch]);

  useEffect(() => {
    if (isAuthenticated && user?.uid) {
      dispatch(getUserSubscription(user?.uid));
    }
  }, [dispatch, isAuthenticated, user]);

  // useEffect(() => {
  //   if (isAuthenticated && user?.uid && currentPlan !== "free") {
  //     dispatch(getUserDefaultPaymentMethod(user?.uid));
  //   }
  // }, [dispatch, isAuthenticated, user]);

  return children;
};

export default AuthInitializer;
